export const tennisRules = [
  {
    title: 'Court Dimensions',
    type: 'info',
    diagram: {
      label: 'Court Size',
      value: '78\' × 36\''
    },
    points: [
      'Singles court: 78 feet long × 27 feet wide',
      'Doubles court: 78 feet long × 36 feet wide',
      'Net height: 3 feet at center, 3.5 feet at posts'
    ],
    keyFact: 'Tennis courts are consistent worldwide, making the game truly international!'
  },
  {
    title: 'Scoring System',
    type: 'info',
    diagram: {
      label: 'Points to Win Set',
      value: '6 games'
    },
    points: [
      'Point progression: 0 (love), 15, 30, 40, game',
      'Must win by 2 points (deuce at 40-40)',
      'Sets won by first to 6 games with 2-game lead',
      'Tiebreak at 6-6 in most formats'
    ],
    keyFact: 'The term "love" for zero comes from the French word "l\'oeuf" (the egg), representing zero\'s oval shape!'
  },
  {
    title: 'Service Rules',
    type: 'do',
    diagram: {
      label: 'Service Attempts',
      value: '2'
    },
    points: [
      'Serve must land in diagonal service box',
      'Two attempts allowed per point (first and second serve)',
      'Must stand behind baseline',
      'Foot faults called if stepping on/over line'
    ],
    keyFact: 'Professional players\' first serves can exceed 140 mph!'
  },
  {
    title: 'Let Calls',
    type: 'info',
    points: [
      'Ball touching net on serve that lands in - replay point',
      'Play interrupted by outside interference - replay point',
      'No let calls on any other shots'
    ],
    keyFact: 'Unlike other sports, players can call lets on themselves in non-professional matches!'
  }
];

export const tennisGoverningBodies = [
  {
    name: 'International Tennis Federation (ITF)',
    description: 'World governing body for tennis. Organizes major tournaments, sets rules, and promotes tennis globally across 211 nations.',
    website: 'https://www.itftennis.com'
  },
  {
    name: 'United States Tennis Association (USTA)',
    description: 'National governing body for tennis in the U.S. Organizes the US Open and promotes tennis development at all levels.',
    website: 'https://www.usta.com'
  }
];

export const tennisTournaments = [
  {
    name: 'Grand Slam Tournaments',
    description: 'The four most prestigious tennis events: Australian Open, French Open, Wimbledon, and US Open. These tournaments offer the most ranking points and prize money.',
    website: 'https://www.itftennis.com/en/about-us/grand-slams/'
  },
  {
    name: 'ATP Tour',
    description: 'Association of Tennis Professionals men\'s tour featuring 63 tournaments worldwide with over $180 million in prize money.',
    website: 'https://www.atptour.com'
  },
  {
    name: 'WTA Tour',
    description: 'Women\'s Tennis Association tour with 50+ tournaments across 6 continents and over $150 million in prize money.',
    website: 'https://www.wtatennis.com'
  },
  {
    name: 'Davis Cup',
    description: 'Premier international team competition for men, featuring 140+ nations competing annually.',
    website: 'https://www.daviscup.com'
  }
];

export const tennisResources = [
  {
    name: 'USTA Tournament Calendar',
    website: 'https://www.usta.com/en/home/play/tournamentschedules.html'
  },
  {
    name: 'Tennis Channel',
    website: 'https://www.tennischannel.com'
  },
  {
    name: 'ATP Rankings',
    website: 'https://www.atptour.com/en/rankings'
  }
];
